import React from 'react';
import {List, Link, NoWrap} from 'components';
import {useNamedSelector} from 'helpers';

export function Alert({ module }) {
  const { plan } = useNamedSelector('session.subscription');
  const { restricted, message } = useNamedSelector('permissions.restricted', { module });
  return restricted && (
    <List small-gutter className="text-center medium-spacing">
      <div>Your { plan } account is limited to { message }.</div>
      <div>To get unlimited access please <NoWrap><Link className="link" to="/settings/membership/">upgrade</Link> your account.</NoWrap></div>
    </List>
  );
}
